export default function tools(state = {}, action) {
    switch (action.type) {
    case 'SET_WIDGET_TOOLS':
        return { ...state, kind: action.kind, widgetId: action.widgetId };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/_app/quick_response/reducers/tools_reducers.js